import { zodResolver } from "@hookform/resolvers/zod";
import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import z from "zod";

import { contactUsDialogSchema } from "./ContactUsDialog.schema";
import { sendContactMessage } from "./ContactUsDialog.services";
import type { ContactUsDialogFormValues } from "./ContactUsDialog.types";

interface UseContactUsDiaogProps {
  setOpen: (open: boolean) => void;
  packageId?: string;
}

export default function useContactUsDialog({ setOpen, packageId }: UseContactUsDiaogProps) {
  const { t } = useTranslation();

  const schema = contactUsDialogSchema(t);

  const form = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      firstName: "",
      lastName: "",
      email: "",
      message: "",
    },
  });

  const { control, handleSubmit } = form;

  function onSubmit(values: z.infer<typeof schema>) {
    const data = {
      ...values,
      packageId,
    };
    sendMessage.mutate(data, {
      onSuccess: () => {
        setOpen(false);
        form.reset();
      },
    });
  }

  const sendMessage = useMutation({
    mutationFn: (data: ContactUsDialogFormValues) => sendContactMessage(data),
    onSuccess: () => {
      toast.success(t("checkout.contactUsDialog.successMessage"));
    },
  });

  return { sendMessage, form, control, handleSubmit, onSubmit };
}
